import {FC, Fragment, ReactElement, useMemo} from 'react';
import {FileError} from 'react-dropzone';
import {Alert} from '../../Alert';
import {Box} from '../../Box';
import {useFileInputContext} from '../FileInputContext';
import {getErrorMessage} from '../utils/getErrorMessage';

const getShortenedFileName = (name: string): ReactElement => {
    const filename = name.substring(0, name.lastIndexOf('.'));
    const extension = name.substring(name.lastIndexOf('.'));

    return (
        <span
            style={{
                display: 'inline-flex',
                verticalAlign: 'top',
                maxWidth: '10rem'
            }}
        >
            <span
                style={{
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden'
                }}
            >{`${filename}`}</span>
            <span>{`${extension}`}</span>
        </span>
    );
};

const errorsToString = (errors: FileError[]): string => {
    let str = '';

    errors.forEach((error, index) => {
        str += error.message;

        if (index < errors.length - 1) {
            str += ', ';
        }
    });

    return str;
};

export const RejectedFileAlert: FC<unknown> = () => {
    const {
        rejectedFiles, textMap
    } = useFileInputContext();

    const renderRejectFiles = useMemo(() => {
        return rejectedFiles.map((rejection, index) => {
            const errors = rejection.errors.map((err) => getErrorMessage(err.code, textMap));

            return (
                <Fragment key={`file-list-item-${index}`}>
                    <span role={'listitem'}>
                        {getShortenedFileName(rejection.file.name)}
                        {' – '}
                        <em>{errorsToString(errors)}</em>
                    </span>
                    {index < rejectedFiles.length && <br/>}
                </Fragment>
            );
        });
    }, [rejectedFiles]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Box marginTop='1rem'>
            <Alert
                title={`${rejectedFiles.length} ${textMap.rejectedFileAlertTitle}`}
                variant='error'
            >
                <span
                    key='rejected-file-list'
                    role={'list'}
                >{renderRejectFiles}</span>
            </Alert>
        </Box>
    );
};
